import { mapGetters, mapMutations } from 'vuex';
import _ from 'lodash';
import { FilterHead } from '@/components';
import isServer from '@/utils/isServer';

if (!isServer) {
  var VueSlider = require('vue-slider-component');
  require('vue-slider-component/theme/default.css');
}
export default {
  name: 'FilterAvailablePlaces',
  components: {
    [FilterHead.name]: FilterHead,
    VueSlider,
  },
  props: {},
  data: () => ({
    filterHead: {
      icon: 'user-friends',
      text: 'Vrije plaatsen',
    },
    filter: {
      isOpen: false,
      availableplace: null,
      marks: [0, 100],
      marksvalue: [0, 100],
    },
  }),
  computed: {
    ...mapGetters('event', {
      getEventFilter: 'getEventFilter',
    }),
    marks: {
      get() {
        if (this.getEventFilter.availablePlaces.length === 0) {
          this.filter.marks = [0, 100];
          return this.filter.marks;
        }
        this.filter.marks = this.getEventFilter.availablePlaces;
        return this.filter.marks;
      },
      // eslint-disable-next-line func-names
      set: _.debounce(function (value) {
        this.filter.marks = value;
        this.filter.availablePlaces = value;

        if (this.filter.availablePlaces[0] === 0 && this.filter.availablePlaces[1] === 100) {
          this.filter.availablePlaces = [];
          this.filter.marks = [];
        }
        this.setEventFilterAvailablePlaces(this.filter.availablePlaces);
      }, 600),
    },
  },
  methods: {
    ...mapMutations('event', {
      setEventFilterAvailablePlaces: 'SET_EVENT_FILTER_AVAILABLE_PLACES',
    }),
    openFilter() {
      this.filter.isOpen = !this.filter.isOpen;
    },
    onDrag(value) {
      this.$set(this.filter, 'marksvalue', value);
    },
  },
  watch: {
    getEventFilter: {
      handler(updatedEventFilter) {
        if (updatedEventFilter.availablePlaces.length) this.$set(this.filter, 'marksvalue', updatedEventFilter.availablePlaces);
        else this.$set(this.filter, 'marksvalue', [0, 100]);
      },
      deep: true,
    },
  },
  created() {
  },
};
